import { render, staticRenderFns } from "./WithdrawDia.vue?vue&type=template&id=5ee46b4d&scoped=true"
import script from "./WithdrawDia.vue?vue&type=script&lang=js"
export * from "./WithdrawDia.vue?vue&type=script&lang=js"
import style0 from "./WithdrawDia.vue?vue&type=style&index=0&id=5ee46b4d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee46b4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee46b4d')) {
      api.createRecord('5ee46b4d', component.options)
    } else {
      api.reload('5ee46b4d', component.options)
    }
    module.hot.accept("./WithdrawDia.vue?vue&type=template&id=5ee46b4d&scoped=true", function () {
      api.rerender('5ee46b4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stake/profile/WithdrawDia.vue"
export default component.exports